import { Box, Stack } from "@mui/material";
import BookingRating from "./BookingRating";
import SmartActionsPanel from "./SmartActionPanel";
import ActionItemCard from "./ActionItems";
import type { SmartAction, ActionItem } from "../../../types/types";

interface SidebarProps {
  rating: number;
  smartActions: SmartAction[];
  actionItems: ActionItem[];
}

type SidebarMode = "ratingOnly" | "smartActionsOnly" | "actionsOnly";

interface SidebarProps {
  rating: number;
  smartActions: SmartAction[];
  actionItems: ActionItem[];
  mode?: SidebarMode;
}

export default function Sidebar({
  rating,
  smartActions,
  actionItems,
  mode = "ratingOnly",
}: SidebarProps) {
  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      {mode === "ratingOnly" && (
        <Box sx={{ height: "100%" }}>
          <BookingRating rating={rating} />
        </Box>
      )}

      {mode === "smartActionsOnly" && (
        <Box sx={{ height: "100%" }}>
          <SmartActionsPanel actions={smartActions} />
        </Box>
      )}

      {mode === "actionsOnly" && (
        <Stack spacing={1}>
          {actionItems.map((item, index) => (
            <ActionItemCard key={index} item={item} />
          ))}
        </Stack>
      )}
    </Box>
  );
}
